import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as StandaloneLogo } from '../../../../assets/images/common/icons/standalone-logo.svg'
import { DATETIME_FORMAT, getMomentInCommunityTimezoneReversed } from '../../../../utility/datesHelper'
import { yardageByLevel, levelColors } from '../../../../utility/curriculumHelper'
import { splitArray } from '../../../../utility/arrayHelper'
import moment from 'moment'

import classes from './AlphaReport.module.scss'
import classNames from 'classnames'

const AlphaReport = () => {
  const { t } = useTranslation()
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const event = useSelector(state => state.nineHoleEvent)
  const startTime = getMomentInCommunityTimezoneReversed(moment(event.eventDate), timezone, DATETIME_FORMAT)

  const filteredStudents = [...event.students]
    .filter((s) => !!s.pairingGroupId)
    .toSorted((a, b) =>
      a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase())
    )

  const groupedStudents = splitArray(filteredStudents, 15)

  return (
    <div id='alpha' className={classes.alphaReport}>
      {groupedStudents.map((students, index) => (
        <div key={index} className='PairingsAlphaTeeSheetPage p-4'>
          <div className='d-flex justify-content-between w-100'>
            <div className={classes.title}>
              {t('events.reports.alpha.title', { name: event.name })}
            </div>
            <StandaloneLogo className={classes.logo}/>
          </div>

          <div className={classes.date}>
            {startTime.format('MMM D, YYYY h:mma')} - {startTime.clone().add(1, 'hours').format('h:mma')}
          </div>
          <div className={classes.header}>
            <div className={classes.startTime}>{t('events.common.time')}</div>
            <div className={classes.hole}>{t('events.common.hole')}</div>
            <div className={classes.yardage}>{t('common.golf.yardage')}</div>
            <div className={classes.players}>{t('events.common.player')}</div>
            <div className={classes.personalBest}>{t('events.common.personalBest')}</div>
          </div>
          {students.map((student) => {
            const group = event.pairings.pairingGroups.find((group) => group.id === student.pairingGroupId)
            return (
              <div
                key={student.id}
                className={classes.studentRow}
              >
                <div className={classes.startTime}>
                  {getMomentInCommunityTimezoneReversed(
                    moment(group?.startTime),
                    timezone,
                    DATETIME_FORMAT
                  ).format('LT')}
                </div>
                <div className={classes.hole}>
                  { `${group?.startHole.value || ''} ${group?.playersGroup.value || ''}` }
                </div>

                <div className={classes.yardage}>
                  {student.level < 6
                    ? t('events.reports.alpha.yards', { yardage: yardageByLevel[student.level] / 9 })
                    : t('common.golf.fullTeeBox')}
                </div>
                <div className={classes.players}>
                  <div className='d-flex flex-wrap'>
                    <div
                      className={classNames(
                        'd-flex align-items-center px-1',
                        classes.studentWrapper
                      )}
                      key={student.id}
                    >
                      <MiniDivisionBadge fill={levelColors[student.level]} className={classes.levelBadge}/>
                      <div className={classes.studentLevel} style={{ color: levelColors[student.level] }}>{student.level}</div>
                      <p className={classes.studentName}>
                        {student.firstName} {student.lastName}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={classes.personalBest}>
                  {student.stats[student.level].recordScore}
                </div>
              </div>
            )
          })}
        </div>
      ))}

    </div>
  )
}

export default AlphaReport
